import { useEffect, useState } from 'react';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import LinkedinPostImagesPreview from './linkedin-post-images-preview.component';
import LinkedinPostVideoPreview from './linkedin-post-video-preview.component';

const LinkedinPostPreview = ({ data }) => {
  const [isVideo, setIsVideo] = useState(false);
  useEffect(() => {
    if (!data) return;
    if (data?.media_data?.count == 1 && data?.media_data.media_data[0].type === PostUtil.MediaType.VIDEO) {
      setIsVideo(true);
    }
  }, [data]);
  return <>{isVideo ? <LinkedinPostVideoPreview data={data} /> : <LinkedinPostImagesPreview data={data} />}</>;
};

export default LinkedinPostPreview;
